<template>
  <div>
    <h1 class="text-center h1">公司实时新闻</h1>
  </div>
</template>

<script>
export default {
  name: 'HomeContentNews'
}
</script>

<style lang="stylus" scoped>
.h1
  padding-top 5rem
  color #333333
  font-size: 1.9rem;
  line-height: 0.9rem
  letter-spacing: 0rem
</style>



// WEBPACK FOOTER //
// src/pages/home/components/ContentNews.vue